/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useTheme } from "../../../../config/emotion";
import { PurposedButtonProps } from "./types";
import EwaButton2 from "./EwaButton/EwaButton2";
import { hwrInfoButtonCss } from "./styles";

type ButtonProps = PurposedButtonProps & { label?: string } & {
  greenColor?: boolean;
};

const HwrInfoButton = (props: ButtonProps) => {
  const { colors } = useTheme();
  const useGreenColor = props.greenColor ?? false;

  return (
    <EwaButton2
      buttonColor={useGreenColor ? colors.save : colors.primaryColor}
      label={props.label || "info"}
      css={hwrInfoButtonCss}
      {...props}
    />
  );
};

export default HwrInfoButton;
